<!--
 * @Author: kiwi_myl
 * @Description: Do not edit
 * @Date: 2021-01-14 16:13:11
 * @LastEditTime: 2021-03-31 14:28:29
 * @FilePath: /wedsVue/visito/src/views/visit.vue
-->
<template>
  <div class="visit">
    <div class="visit_chunk">
      <div class="headline">
        系统浏览量统计
      </div>
      <div class="date">
        <div @click="time(1)" :class="time_num === 1 ? 'activate' : ''">
          今日
        </div>
        <div @click="time(2)" :class="time_num === 2 ? 'activate' : ''">
          本周
        </div>
        <div @click="time(3)" :class="time_num === 3 ? 'activate' : ''">
          本月
        </div>
         <div @click="time(4)" :class="time_num === 4 ? 'activate' : ''">
          自定义
        </div>
      </div>

 <div v-if="time_num===4" class="dates" >
      <div @click="beginShow=true">
           {{begin}}
     <van-icon name="arrow-down"  />
      </div>
     <div class="xian">-</div>
     <div @click="endShow=true">{{end}}
     <van-icon name="arrow-down" /></div>
   
    </div>
<van-popup v-model:show="beginShow"  position="bottom">
      <van-datetime-picker
  v-model="beginDate"
  type="date"
  title="选择年月日"
  :max-date="maxDate"
  @confirm="onConfirm"
  @cancel='onCancel'
/>
</van-popup>
<van-popup v-model:show="endShow"  position="bottom">
      <van-datetime-picker
  v-model="endDate"
  type="date"
  title="选择年月日"
  :max-date="maxDate"
  @confirm="onConfirmDnd"
  @cancel='onCancel'
/>
</van-popup>

      <div class="item">
        <div class="left">
          <img src="../assets/images/laoshi.png" alt="" />
        </div>
        <div class="right">
          <div class="role">老师</div>
          <div class="numTab">
            <img src="../assets/images/yan.png" alt="" />

            <span>浏览量</span>
          </div>
          <div class="num">{{ teacher_num }}</div>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <img src="../assets/images/jiazhang.png" alt="" />
        </div>
        <div class="right">
          <div class="role">家长</div>
          <div class="numTab">
            <img src="../assets/images/yan.png" alt="" />

            <span>浏览量</span>
          </div>
          <div class="num">{{ parent_num }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { DatetimePicker,Popup ,Toast,Icon} from "vant";
import dayjs from "dayjs"
import Account from "@/api/account";
export default defineComponent({
  name: "visit",
 components: {
    "van-datetime-picker": DatetimePicker,
       "van-popup": Popup,
        "van-icon": Icon,
  },
  setup() {
    document.title = "访问量统计";
    const teacher_num = ref(0);
    const parent_num = ref(0);
    const time_num = ref(1);
   const  beginShow = ref(false);
   const  endShow = ref(false);
 
    const begin= ref('');
      const end= ref('');
  const endDate= ref(new Date());
  begin.value=dayjs().subtract(7, 'day').format('YYYY-MM-DD');
  end.value=dayjs(new Date()).format('YYYY-MM-DD');
   const beginDate= ref(new Date(begin.value));
    const route = useRoute();
    const time = (i: number) => {
      time_num.value = i;
      getanalyseUv();
    };

   const onConfirm = (val:any) => {
      begin.value=dayjs(val).format('YYYY-MM-DD')
     beginShow.value=false
          if(dayjs(begin.value).unix() > dayjs(end.value).unix()) return  Toast.fail('开始时间不能低于结束时间')
     getanalyseUv();
    };
      const onConfirmDnd = (val:any) => {
      end.value=dayjs(val).format('YYYY-MM-DD')
        endShow.value=false
     if(dayjs(begin.value).unix() > dayjs(end.value).unix()) return  Toast.fail('开始时间不能低于结束时间')
         getanalyseUv();
 };

    const onCancel = () => {
     beginShow.value=false
     endShow.value=false
    };
    
    const getanalyseUv = async () => {

        let datas:any = {
          timespan: time_num.value,
        school_id: route.query.school_id
        }

        if( time_num.value===4){
            datas = {
                 timespan: time_num.value,
        school_id: route.query.school_id,
        begin:dayjs(begin.value).unix(),
        end: dayjs(end.value).unix()
        }
            
        }
      const [err, data] = await Account.getanalyseUv(datas);
      if (err) return;
      teacher_num.value = data.teacher_number;
      parent_num.value = data.parent_number;
    };

    onMounted(() => {
      getanalyseUv();
    });

    return {
      teacher_num,
      parent_num,
      time_num,
      time,
      beginDate,
      endDate,
      begin,
      end,
      maxDate:new Date(),
      beginShow,
       endShow,
      onConfirm,
      onCancel,
      onConfirmDnd,
    };
  }
});
</script>
<style scoped lang="scss">
.visit {
    .dates{
     color:#333;
     font-size: 15px;
     display: flex;
     justify-content: center;
     align-items: center;
     
     .van-icon{
         margin-left: 2px;
       font-size: 12px;
     }
     .xian{
         
        margin: 0 10px;
     }
     div{
      
         height: 40px;
     
     }
      
    }
  .visit_chunk {
    padding: 109px 22px;
    text-align: center;
    .headline {
      font-size: 22px;
      font-weight: bold;
      color: #000;
    }
    .date {
      display: flex;
      justify-content: center;
      align-content: center;
      margin: 24px 0;
      div {
        border: 1px solid #a1a1a1;
        width: 78px;
        height: 25px;
        border-radius: 12px;
        line-height: 25px;
        font-size: 15px;
        color: #333;
        margin-left: 7px;
      }

      .activate {
        border: 1px solid #558dff;
        color: #558dff;
      }
    }
    .item {
      width: 100%;
      height: 124px;
      border: 1px solid #d8e4f3;
      box-shadow: 2px 6px 10px 0px rgba(126, 158, 193, 0.15);
      border-radius: 10px;
      display: flex;
      justify-content: space-around;
      align-content: center;
      text-align: left;
      margin-bottom: 20px;
      .left {
        img {
          width: 114px;
          height: 110px;
          padding: 14px 32px 0 17px;
        }
      }
      .right {
        padding-top: 24px;
        flex: 1;
        .role {
          font-size: 26px;
          font-weight: bold;
          color: #000;
        }
      }
      .numTab {
        img {
          width: 15px;
          height: 12px;
          vertical-align: middle;
        }
        font-size: 12px;
        color: #848484;
      }
      .num {
        color: #558dff;
        font-size: 39px;
      }
    }
  }
}
</style>
